import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const HelpLine = () => {
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchListData = () => {
    axios.post(API_URL.HELPLINE_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          setListData(res.data.data);
        }
        setLoading(false);
        if (sessionStorage.getItem("pId")) {
          let rId = "row-" + JSON.parse(sessionStorage.getItem("pId"));
          setTimeout(() => {
            scrollToRow(rId);
          }, 100);
        }
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          
        });
      }
    );
  };

  const deleteSize = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.HELPLINE_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = listData.filter((r) => r.id != row.id);
              setListData(newData);
            }
            toast.success("Delete Successfully", { autoClose: 3000 });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    fetchListData();
  }, []);

  const scrollToRow = (rowId) => {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            HelpLine
            <small className="me-2">({listData.length})</small>
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/settings/help-line/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              HelpLine
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Phone No.</th>
                        <th  className="text-center"
                            style={{ width: "200px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {listData.map((row, key) => {
                        return (
                          <tr id={"row-" + row.id} key={key}>
                            <td style={{ width: "10px" }}>{key + 1}</td>
                            <td>{row.name}</td>
                            <td>{row.phone_number}</td>
                            <td
                              className="d-flex justify-content-center gap-2"
                              style={{ width: "200px" }}
                            >
                              <Link
                                to={"/settings/help-line/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteSize(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpLine;
